import { useEffect } from 'react';
import { MarzipanoViewer } from './components/MarzipanoViewer';
import { SceneList } from './components/SceneList';
import { Toolbar } from './components/Toolbar';
import { useTourStore } from './hooks/useTourStore';
import { useMediaQuery } from './hooks/useMediaQuery';

export default function App() {
  const setSceneListOpen = useTourStore((s) => s.setSceneListOpen);
  const isDesktop = useMediaQuery('(min-width: 1024px)');

  useEffect(() => {
    if (isDesktop) {
      setSceneListOpen(true);
    }
  }, [isDesktop, setSceneListOpen]);

  return (
    <MarzipanoViewer>
      <Toolbar />
      <SceneList />
    </MarzipanoViewer>
  );
}
